import { FC } from 'react';

import { SFFooterViewModel } from '@api/index';
import Markdown from '@components/utils/Markdown';

import { Wrapper } from './styled';

export type CorporateContent = Pick<SFFooterViewModel, 'corporateContent'>;

const FooterContent: FC<CorporateContent> = ({ corporateContent }) => {
  return (
    <Wrapper>
      <Markdown text={corporateContent} />
      Shopandfly.com.tr sitesinin tüm seyahat hizmetleri Setur Seyahat
      Acenteliği tarafından verilmektedir.
    </Wrapper>
  );
};
export default FooterContent;
